import { useSelector } from 'react-redux';

// project imports
import { selectPermissionCodes } from './authSlice';

// ==============================|| HOOK - PERMISSION ||============================== //
// usage: const hasPermission = usePermission(); hasPermission('clientes.create')
// also accepts an array to mean "has ANY of these codes"

export function usePermission() {
  const permissionCodes = useSelector(selectPermissionCodes);

  return (code) => (Array.isArray(code) ? code.some((single) => permissionCodes.includes(single)) : permissionCodes.includes(code));
}
